var _a, _b, _c, _d;
export class AuthRole {
}
_a = AuthRole;
AuthRole.QUESTIONER = 'Questioner';
AuthRole.MENTOR = 'Mentor';
AuthRole.ADMIN = 'Admin';
AuthRole.loggedIn = (role) => {
    let index = [_a.QUESTIONER, _a.MENTOR, _a.ADMIN].indexOf(role);
    return index !== -1;
};
export class PlanCategory {
}
PlanCategory.GUEST_PLAN = 1;
PlanCategory.FREE_PLAN = 2;
export class AccountType {
}
_b = AccountType;
AccountType.USUALLY = 1;
AccountType.CURRENT = 2;
AccountType.LIST = [
    { id: _b.USUALLY, name: '普通' },
    { id: _b.CURRENT, name: '当座' },
];
export class UserType {
}
_c = UserType;
UserType.TEMPORARY_REGISTRATION = 0;
UserType.QUESTIONER = 1;
UserType.EXAM_ACCEPTANCE = 2;
UserType.MENTOR = 3;
UserType.LIST = [
    { id: _c.TEMPORARY_REGISTRATION, name: '仮登録' },
    { id: _c.QUESTIONER, name: '相談者' },
    { id: _c.EXAM_ACCEPTANCE, name: '審査受付' },
    { id: _c.MENTOR, name: 'メンター' },
];
export class HelpType {
}
HelpType.QUESTIONER = 1;
HelpType.MENTOR = 3;
HelpType.COMMON = 0;
export class QuestionType {
}
_d = QuestionType;
QuestionType.ACCEPTING = 1;
QuestionType.UNDER_EVALUATION = 2;
QuestionType.ACCEPTED = 3;
QuestionType.HIGHLY_RATED = 4;
QuestionType.MY_POSTS = 5;
QuestionType.REPLY_UNREAD = 6;
QuestionType.ALL = 7;
QuestionType.LIST = [
    { id: _d.ACCEPTING, name: '受付中' },
    { id: _d.UNDER_EVALUATION, name: '評価中' },
    { id: _d.ACCEPTED, name: '受付済' },
    { id: _d.HIGHLY_RATED, name: '高評価' },
    { id: _d.MY_POSTS, name: 'マイ投稿' },
    { id: _d.REPLY_UNREAD, name: '返信未読' },
    { id: _d.ALL, name: '全て' },
];
export class ProfileUpdateType {
}
ProfileUpdateType.NAME = 'name';
ProfileUpdateType.INDUSTRY = 'industry';
ProfileUpdateType.JOB = 'job';
ProfileUpdateType.COMPANY_PROFILE = 'company_profile';
ProfileUpdateType.ANNUAL_SALE = 'annual_sale';
ProfileUpdateType.EMPLOYEE = 'employee';
ProfileUpdateType.SELF_INTRODUCTION = 'self_introduction';
ProfileUpdateType.SKILL_SUMMARY = 'skill_summary';
ProfileUpdateType.REAL_NAME = 'real_name';
ProfileUpdateType.KANA_NAME = 'kana_name';
ProfileUpdateType.TEL = 'tel';
ProfileUpdateType.ADDRESS = 'address';
ProfileUpdateType.EDUCATION = 'education';
ProfileUpdateType.QUALIFICATION = 'qualification';
ProfileUpdateType.LANGUAGE = 'language';
ProfileUpdateType.CAREER_PUBLIC_SETTING = 'career_public_setting';
ProfileUpdateType.CAREER_CREATE = 'career_create';
ProfileUpdateType.CAREER_UPDATE = 'career_update';
ProfileUpdateType.CAREER_DELETE = 'career_delete';
ProfileUpdateType.IS_NOTIFICATION_RECEIVING = 'is_notification_receiving';
ProfileUpdateType.PHOTO = 'photo';
export class PayeeUpdatedType {
}
PayeeUpdatedType.REWARD = 'reward';
PayeeUpdatedType.PAYEE = 'payee';
export class QuestionCount {
}
QuestionCount.NO_REMAINING_QUESTION_COUNT = 0;
export class UserLeaveState {
}
UserLeaveState.VALID = 0; // 有効
UserLeaveState.UNPAID_LEAVE = 1; // 未払休会
UserLeaveState.FORCED_WITHDRAWAL = 2; // 強制退会
UserLeaveState.VOLUNTARY_WITHDRAWAL = 3; // 自主退会
export class LeaveReason {
}
LeaveReason.OTHER_REASON = 0; // その他
export class SessionTimeOut {
}
SessionTimeOut.CODE = 419;
SessionTimeOut.MESSAGE = "一定時間画面を操作されなかったため、\n接続を切断させていただきました。\n最初からやり直してください。";
